// NotificationDropdown.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchUpcomingEvents, markEventSeen } from '../../Redux/Actions/actions';
import styles from './NotificationDropdown.module.css';
import campaign from '../../Assets/campana.png';

const TIPO_COLORS = {
  reunion: '#2196F3',
  visita: '#4CAF50',
  recordatorio: '#FF9800',
  vencimiento: '#F44336',
  personal: '#9C27B0',
  otro: '#607D8B',
};

const TIPO_LABELS = {
  reunion: 'Reunión',
  visita: 'Visita',
  recordatorio: 'Recordatorio',
  vencimiento: 'Vencimiento',
  personal: 'Personal',
  otro: 'Otro',
};

const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const user = useSelector(state => state.user);
  const upcomingEvents = useSelector(state => state.upcomingEvents || []);
  const userId = user?.user?.id;

  const loadNotifications = useCallback(() => {
    if (userId) {
      dispatch(fetchUpcomingEvents(7, userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    loadNotifications();
    const interval = setInterval(loadNotifications, 300000); // 5 min
    return () => clearInterval(interval);
  }, [loadNotifications]);

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Contar no vistos
  const unseenCount = upcomingEvents.filter(ev => {
    if (!ev.agentes) return false;
    const myAssignment = ev.agentes.find(a => a.id === userId);
    return myAssignment && !myAssignment.EventoAgente?.visto;
  }).length;

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleEventClick = (ev) => {
    // Marcar como visto
    if (userId) {
      const myAssignment = ev.agentes?.find(a => a.id === userId);
      if (myAssignment && !myAssignment.EventoAgente?.visto) {
        dispatch(markEventSeen(ev.id, userId));
      }
    }
    setIsOpen(false);
    navigate('/calendario');
  };

  const formatDate = (fecha) => {
    if (!fecha) return '';
    const iso = /^\d{4}-\d{2}-\d{2}/.test(fecha) ? fecha.slice(0, 10) : fecha;
    const [y, m, d] = iso.split('-');
    return `${d}/${m}`;
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      <button className={styles.bellButton} onClick={handleToggle}>
        <img className={styles.bellIcon} src={campaign} alt="Notificaciones" />
        {unseenCount > 0 && (
          <span className={styles.badge}>{unseenCount > 9 ? '9+' : unseenCount}</span>
        )}
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>
            <h4 className={styles.dropdownTitle}>Próximos eventos</h4>
            <span className={styles.dropdownCount}>{upcomingEvents.length} evento(s)</span>
          </div>

          <div className={styles.dropdownBody}>
            {upcomingEvents.length === 0 ? (
              <div className={styles.empty}>
                <span>📅</span>
                <p>No hay eventos próximos</p>
              </div>
            ) : (
              upcomingEvents.map(ev => {
                const myAssignment = ev.agentes?.find(a => a.id === userId);
                const isUnseen = myAssignment && !myAssignment.EventoAgente?.visto;
                return (
                  <div
                    key={ev.id}
                    className={`${styles.notifItem} ${isUnseen ? styles.notifItemUnseen : ''}`}
                    onClick={() => handleEventClick(ev)}
                  >
                    <div
                      className={styles.notifDot}
                      style={{ background: ev.color || TIPO_COLORS[ev.tipo] || TIPO_COLORS.otro }}
                    />
                    <div className={styles.notifContent}>
                      <div className={styles.notifTitle}>{ev.titulo}</div>
                      <div className={styles.notifMeta}>
                        <span>{formatDate(ev.fecha)}</span>
                        {ev.horaInicio && <span>{ev.horaInicio.slice(0, 5)}</span>}
                        <span className={styles.notifTipo}>
                          {TIPO_LABELS[ev.tipo] || 'Otro'}
                        </span>
                      </div>
                    </div>
                    {isUnseen && <span className={styles.newBadge}>Nuevo</span>}
                  </div>
                );
              })
            )}
          </div>

          <div className={styles.dropdownFooter}>
            <button className={styles.viewAllBtn} onClick={() => { setIsOpen(false); navigate('/calendario'); }}>
              Ver calendario completo →
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
